<template>
    <li class="nav-item dropdown">
        <a class="nav-icon dropdown-toggle" href="#" id="serverAdministrationDropdown" data-toggle="dropdown"
           aria-haspopup="true" aria-expanded="false">
            <div class="position-relative">
                <i class="fas fa-server"></i>
            </div>
        </a>
        <div v-loading="isLoading" class="dropdown-menu dropdown-menu-lg dropdown-menu-right pb-0" aria-labelledby="serverAdministrationDropdown"
             style="width: 25rem;">
            <div class="dropdown-menu-header">
                Операции с сервером и ЦРМ
            </div>
            <form action="">
                <ul v-if="$hasPermission('command.supervisor_restart')" class="list-group list-group-">
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                            <el-tooltip class="item" effect="dark" content="Очереди, демоны" placement="top">
                                <div class="cursor-pointer">Supervisor</div>
                            </el-tooltip>
                        </div>
                        <div><button type="button" :disabled="isLoading" @click="supervisorRestart" class="btn btn-link" form=""><i class="fas fa-sync-alt"></i> Рестарт</button></div>
                    </li>
                </ul>
                <ul v-if="$hasPermission('command.asterisk_restart')" class="list-group list-group-">
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex align-items-center">Asterisk</div>
                        <div>
                            <button type="button" :disabled="isLoading" @click="asteriskRestart(3)" class="btn btn-link" form=""><i class="fas fa-sync-alt"></i> IP *.131</button>
                            <button type="button" :disabled="isLoading" @click="asteriskRestart(4)" class="btn btn-link" form=""><i class="fas fa-sync-alt"></i> IP *.134</button>
                        </div>
                    </li>
                </ul>
                <ul v-if="$hasPermission('command.phpfpm_restart')" class="list-group list-group-">
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                            <el-tooltip class="item" effect="dark" content="Менеджер процессов PHP" placement="top">
                                <div class="cursor-pointer">PHP-FPM</div>
                            </el-tooltip>
                        </div>
                        <div><button type="button" :disabled="isLoading" @click="phpfpmRestart" class="btn btn-link" form=""><i class="fas fa-sync-alt"></i> Рестарт</button></div>
                    </li>
                </ul>
                <ul v-if="$hasPermission('command.nginx_restart')" class="list-group list-group-">
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                            <el-tooltip class="item" effect="dark" content="Веб-сервер" placement="top">
                                <div class="cursor-pointer">NGINX</div>
                            </el-tooltip>
                        </div>
                        <div><button type="button" :disabled="isLoading" @click="nginxRestart" class="btn btn-link" form=""><i class="fas fa-sync-alt"></i> Рестарт</button></div>
                    </li>
                </ul>

                <ul v-if="$hasPermission('command.cache_clear')" class="list-group list-group-">
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex align-items-center">CRM Cache</div>
                        <div><button type="button" :disabled="isLoading" @click="cacheClear" class="btn btn-link" form=""><i class="fas fa-trash-alt"></i> Очистить</button></div>
                    </li>
                </ul>
                <ul v-if="$hasPermission('command.users_refresh') || $hasPermission('command.users_logout')" class="list-group list-group-">
                    <li class="list-group-item d-flex justify-content-between">
                        <div class="d-flex align-items-center">Пользователи CRM</div>
                        <div>
                            <button v-if="$hasPermission('command.users_refresh')" type="button" :disabled="isLoading" @click="usersRefresh" class="btn btn-link" form=""><i class="fas fa-sync-alt"></i> CTR+R</button>
                            <button v-if="$hasPermission('command.users_logout')" type="button" :disabled="isLoading" @click="usersLogout" class="btn btn-link" form=""><i class="fas fa-sign-out-alt"></i> Разлогин</button>
                        </div>
                    </li>
                </ul>
            </form>
<!--            <button type="button" class="btn btn-primary" form="">NGINX - рестарт</button>-->
<!--            <button type="button" class="btn btn-primary" form="">Кеш - очистить</button>-->
        </div>
    </li>
</template>

<script>
export default {
    name: "ServerAdministrationBlock",
    data: () => ({
        isLoading: false,
    }),
    methods: {
        supervisorRestart() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/server/supervisor_restart')
                .then((r) => {
                    self.isLoading = false;
                    self.notification('success', 'Supervisor перезагружен')
                })
                .error((r) => {
                    self.isLoading = false;
                    self.notification('danger', 'Supervisor - что-то пошло не так', r.data.join("<br />"))
                })
        },
        asteriskRestart(id) {
            let self = this;
            self.isLoading = true;
            axios.post('/api/server/asterisk_restart', {
                id: id
            })
                .then((r) => {
                    self.isLoading = false;
                    self.notification('success', 'Asterisk перезагружен')
                })
                .catch((r) => {
                    self.isLoading = false;
                    self.notification('danger', 'Asterisk - что-то пошло не так')
                })
        },
        phpfpmRestart() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/server/phpfpm_restart')
                .finally((r) => {
                    self.isLoading = false;
                    self.notification('success', 'PHP-FPM перезагружен')
                })
        },
        nginxRestart() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/server/nginx_restart')
                .finally((r) => {
                    self.isLoading = false;
                    self.notification('success', 'NGINX перезагружен')
                })
        },
        cacheClear() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/server/cache_clear')
                .then((r) => {
                    self.isLoading = false;
                    self.notification('success', 'CRM Cache очищен')
                })
                .catch((r) => {
                    self.isLoading = false;
                    self.notification('danger', 'CRM Cache - что-то пошло не так', r.data.join("<br />"))
                })
        },
        usersRefresh() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/server/users_refresh')
                .then((r) => {
                    self.isLoading = false;
                    self.notification('success', 'Пользователи CRM (CTRL+R) - готово')
                })
                .error((r) => {
                    self.isLoading = false;
                    self.notification('danger', 'Пользователи CRM (CTRL+R) - что-то пошло не так', r.data.join("<br />"))
                })
        },
        usersLogout() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/server/users_logout')
                .then((r) => {
                    self.isLoading = false;
                    self.notification('success', 'Пользователи CRM (Разлогин) - готово')
                })
                .error((r) => {
                    self.isLoading = false;
                    self.notification('danger', 'Пользователи CRM (Разлогин) - что-то пошло не так', r.data.join("<br />"))
                })
        },
        notification(color, title, message) {
            this.$vs.notification({
                color: color,
                position: 'top-right',
                title: title,
                text: message,
                buttonClose: true,
                duration: 10000,
            });
        },
    }
}

</script>

<style scoped>

</style>
